export const BRANDED_SERVER_ERROR = 'Something went wrong on our end. Please try again in a few minutes.'
export const BRANDED_CLIENT_ERROR = "We couldn't complete your request. Please try again."
export const BRANDED_TIMEOUT_ERROR = 'The request took too long. Please check your connection and try again.'
export const BRANDED_NETWORK_ERROR =
  "We couldn't reach the server. Please check your internet connection and try again."

export function classifyRequestError(error: Error): string {
  if (error.name === 'TimeoutError' || error.name === 'AbortError') {
    return BRANDED_TIMEOUT_ERROR
  }
  return BRANDED_NETWORK_ERROR
}

export function classifyResponseError(status: number): string {
  return status >= 500 ? BRANDED_SERVER_ERROR : BRANDED_CLIENT_ERROR
}
